<template>
  <div class="container mx-auto px-4 py-2 bg-white mb-2">
    <div class="max-w-6xl mx-auto">
      <!-- Customer Account Menu - Persistent across all account pages -->
      <section class="mb-4 md:mt-4">
        <CustomerAccountMenu
          v-model="activeMenu"
          :is-verified="isEmailVerified"
          @select="handleMenuSelect"
        />
      </section>

      <!-- Page content slot -->
      <router-view v-slot="{ Component }">
        <keep-alive>
          <component :is="Component" />
        </keep-alive>
      </router-view>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useAuthStore } from '@/store/auth'
import CustomerAccountMenu from '@/components/CustomerAccountMenu.vue'

const router = useRouter()
const route = useRoute()
const authStore = useAuthStore()

// Map route names to menu values
const routeToMenuMap = {
  'TripHub': 'TripHub',
  'Rewards': 'Rewards',
  'Community': 'Community',
  'Subscription': 'Subscription',
  'Alerts': 'Alerts',
  'Profile': 'Profile'
}

// Active menu based on current route
const activeMenu = computed({
  get: () => routeToMenuMap[route.name] || 'TripHub',
  set: (value) => {
    // Menu selection is handled by handleMenuSelect
  }
})

// Email verification status
// Note: Backend returns email_verified, not is_verified
const isEmailVerified = computed(() => authStore.user?.email_verified || false)

// Handle menu selection
const handleMenuSelect = (menuValue) => {
  const menuToRouteMap = {
    'TripHub': 'TripHub',
    'Rewards': 'Rewards',
    'Community': 'Community',
    'Subscription': 'Subscription',
    'Alerts': 'Alerts',
    'Profile': 'Profile'
  }
  
  const routeName = menuToRouteMap[menuValue]
  if (routeName && route.name !== routeName) {
    router.push({ name: routeName })
  }
}
</script>
